import React from 'react';
import StepIndicator from './StepIndicator';
import { useTranslation } from 'react-i18next';

function formatPrice(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return null;
  const num = Number(amount);
  return num.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
}

function ExpensiveScreen({
  onBack,
  onClose,
  onClaimDiscount,
  onCancelAnyway,
  isSubmitting,
  subscriptionAmount,
  canClaimDiscount = true,
}) {
  const { t } = useTranslation();
  const currentAmount = subscriptionAmount != null ? Number(subscriptionAmount) : null;
  const discountedAmount = currentAmount != null ? currentAmount * 0.8 : null;
  const originalFormatted = formatPrice(currentAmount);
  const discountedFormatted = formatPrice(discountedAmount);

  return (
    <>
      <StepIndicator step={2} onBack={onBack} showBack onClose={onClose} />

      <div className="t-mb-4">
        <h2 className="t-text-[26px] t-font-serif t-text-slate-900 t-leading-tight t-mb-2">
          {t('CancelFlow_Expensive_Title_Line1')}
          <br />
          <span>
            {t('CancelFlow_Expensive_Title_Line2').split(' ').slice(0, -1).join(' ')}{' '}
            <em className="t-text-secondary">
              {t('CancelFlow_Expensive_Title_Line2').split(' ').slice(-1).join(' ')}
            </em>
          </span>
        </h2>
        <p className="t-text-sm t-text-slate-600 t-m-0">{t('CancelFlow_Expensive_Subtitle')}</p>
      </div>

      <div className="t-bg-gradient-to-br t-from-[#005d67] t-to-[#1A6B5A] t-rounded-2xl t-px-5 t-py-5 t-text-white t-mb-4 t-relative t-overflow-hidden t-shadow-lg">
        <div className="t-absolute -t-top-8 -t-right-8 t-w-36 t-h-36 t-rounded-full t-bg-white/5" />
        <div className="t-inline-flex t-items-center t-gap-1 t-bg-[#D4A843] t-text-slate-900 t-text-[11px] t-font-semibold t-uppercase t-tracking-[0.06em] t-rounded-full t-px-3 t-py-1 t-mb-3 relative">
          <span>⭐</span>
          <span>{t('CancelFlow_Expensive_Badge')}</span>
        </div>
        <div className="t-font-serif t-text-[30px] t-leading-none t-mb-1">
          {t('CancelFlow_Expensive_OfferTitle')}
        </div>
        <p className="t-text-[13px] t-text-white/80 t-mb-3">
          {t('CancelFlow_Expensive_OfferSubtitle')}
        </p>
        <div className="t-flex t-items-baseline t-gap-2">
          <div className="t-font-serif t-text-[26px]">
            {discountedFormatted ?? '39,20€'}{' '}
            <sub className="t-font-sans t-text-[12px] t-opacity-80">
              {t('CancelFlow_Expensive_PerMonth')}
            </sub>
          </div>
          {originalFormatted && (
            <div className="t-text-sm t-line-through t-text-white/60">{originalFormatted}</div>
          )}
          <div className="t-text-[12px] t-text-white/70 t-ml-auto">
            {t('CancelFlow_Expensive_ForMonths')}
          </div>
        </div>
      </div>

      <div className="t-flex t-items-center t-gap-2 t-bg-teal-bg t-border-l-4 t-border-secondary t-rounded-lg t-px-3 t-py-2 t-text-[12px] t-text-slate-700 t-mb-4">
        <span className="t-text-secondary">🛡</span>
        <span>{t('CancelFlow_Expensive_Info')}</span>
      </div>

      {canClaimDiscount ? (
        <button
          type="button"
          onClick={onClaimDiscount}
          disabled={isSubmitting}
          className="t-w-full t-inline-flex t-items-center t-justify-center t-rounded-xl t-px-4 t-py-3 t-bg-secondary t-text-white t-font-semibold t-text-sm t-gap-2 t-shadow-sm hover:t-shadow-[0_4px_12px_rgba(26,107,90,0.28)] t-transition t-mb-2 disabled:t-opacity-50 disabled:t-cursor-not-allowed"
        >
          <span>{t('CancelFlow_Expensive_Claim')}</span>
          <span aria-hidden="true">✓</span>
        </button>
      ) : (
        <p className="t-rounded-lg t-bg-slate-100 t-px-3 t-py-2 t-text-center t-text-xs t-text-slate-600 t-mb-2">
          {t('CancelFlow_Expensive_Unavailable')}
        </p>
      )}

      <button
        type="button"
        onClick={onCancelAnyway}
        disabled={isSubmitting}
        className="t-block t-w-full t-text-center t-text-sm t-text-slate-600 hover:t-text-slate-800"
      >
        {t('CancelFlow_Expensive_CancelAnyway')}
      </button>
    </>
  );
}

export default ExpensiveScreen;
